<template>
    <v-navigation-drawer v-model="showNav" app clipped persistent right style="background-color:#fafafc" >
        <v-toolbar flat color="#fafafc">
            <v-toolbar-title>
                Patient Search
            </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="patientSearchResults" flat color="#fafafc">
            <v-toolbar-title>
                Results
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="clearTheResults" icon><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card v-if="!patientSearchResults" flat>
        <v-card-text class="pa-2">
          <v-text-field v-model="firstNameInput" class="mb-2" hide-details outline label="First Name">
          </v-text-field>
          <v-text-field v-model="lastNameInput" class="mb-2" hide-details outline label="Last Name">
          </v-text-field>
          <v-text-field v-model="birthdateInput" class="mb-2" outline persistent-hint hint="mm/dd/yyyy" label="Birthdate">
          </v-text-field>
          
        </v-card-text>
        <v-layout column>
            <v-btn @click="launchSearch" depressed color="primary" dark>search</v-btn>
          </v-layout>
        </v-card>
        <v-list v-if="patientSearchResults" two-line>
          <v-list-tile row v-for="(patient, item) in patientSearchResults" :key="item">
            <v-list-tile-content>
            <v-list-tile-title>
              {{patient.firstName}} {{patient.lastName}}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{patient.birthdate}}
            </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
     
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import dateFormat from 'date-fns/format'
import bus from '@/core/helpers/bus'
import HelperMixin from '@/core/mixins/HelperMixin'

export default {
  mixins: [HelperMixin],
  methods: {
    ...mapActions('admin', [
      'getPatientList',
      'getUserList',
      'getRequest',
      'getRequestProvider',
      'setStatus',
      'sendRequest',
      'getRequestOverrides',
      'submitRequestOverrides',
      'submitRequestNote',
      'getDocumentFiles',
      'searchForPatient'
    ]),
    ...mapMutations('admin', [
      'setPatientSearchResults'
    ]),
    clearTheResults() {
      this.setPatientSearchResults(null)
    },
    pullRequest() {
      let vm = this
      vm.getRequest(vm.$route.params.id).then(() => {
        vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight
      })
    },
    launchSearch() {
      if (this.firstNameInput || this.lastNameInput) {
        this.searchForPatient({
          firstName: this.firstNameInput,
          lastName: this.lastNameInput
        })
      }
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    parseTimestamp(timestamp) {
      const ts = new Date(parseInt(timestamp) * 1000)
      return dateFormat(ts, 'MMM D YYYY HH:MM:ss Z')
    },
    alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate'
      } else {
        return 'grayAlternate'
      }
    }
  },
  data() {
    return {
      logEntryInput: null,
      updatingLog: false,
      showNav: false,
      firstNameInput: null,
      lastNameInput: null,
      birthdateInput: null
    }
  },
  watch: {
    $route(val) {
      console.log(val)
    },
    request(val) {
      console.log('request is back')
      if (val && this.$refs.chatScroll) {
        let vm = this
        vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight
      }
    }
  },
  computed: {
    ...mapState('admin', [
      'patientSearchResults',
      'userSearchResults',
      'request',
      'files'
    ]),
    ...mapState('auth', ['user'])
  },
  mounted() {
    this.showNav = true
  }
}
</script>

<style>
.messages {
  height: calc(100vh - 255px);
  width: 100%;
}
.grayAlternate {
  background-color: #ffffff;
}
.whiteAlternate {
  background-color: #fafafc;
}
</style>



// WEBPACK FOOTER //
// src/components/PatientAssignment.vue